module.exports = __webpack_public_path__ + "img/walkthrough_illust22@2x.0215fddd.png";